export enum RegCodeKey {
  CLIENTLESS = 'com.turner.top-2.clientlessRegCode',
}
